type TranslatableItem = {
  text: string;
  [key: string]: any;
};

export const translateItems = <T extends TranslatableItem>(
  items: T[],
  t: (key: string) => string,
): T[] => {
  return items.map((item) => ({
    ...item,
    text: t(item.text),
  }));
};
